import React from "react";
import { Flex } from "../../../Flex";
import { Field } from "formik";
import { FormikRadioButton } from "../../../FormikRadioButton";

interface Props {
  id: string;
  namePrefix: string;
  currentValue: string;
  showSiteContactOption?: boolean;
  showPropertyOwnerContactOption?: boolean;
  disableSiteContactOption?: boolean;
  disablePropertyOwnerContactOption?: boolean;
}

export const DisconnectionContactDetailsRoleRadio: React.FC<Props> = ({
  id,
  namePrefix,
  currentValue,
  showSiteContactOption,
  showPropertyOwnerContactOption,
  disableSiteContactOption,
  disablePropertyOwnerContactOption,
}) => {
  return (
    <Flex id={id} flexDirection={["column", "column", "row"]}>
      <Flex
        flexDirection="column"
        flexGrow={0.5}
        flexBasis={0}
        mr={[0, 0, 2]}
        mb={[2, 2, 0]}
      >
        <Field
          id={`${id}-requester`}
          magnitude="small"
          label="Same as requester"
          name={namePrefix}
          value="requester"
          currentValue={currentValue}
          flexGrow={0.5}
          flexBasis={0}
          minWidth={0}
          mr={[2, 2, 3]}
          component={FormikRadioButton}
          useTimeout
        />
      </Flex>
      {showSiteContactOption && (
        <Flex
          flexDirection="column"
          flexGrow={0.5}
          flexBasis={0}
          mr={[0, 0, 2]}
          mb={[2, 2, 0]}
        >
          <Field
            id={`${id}-site-access-contact`}
            magnitude="small"
            label="Same as site contact"
            name={namePrefix}
            value="site-access-contact"
            currentValue={currentValue}
            flexGrow={0.5}
            flexBasis={0}
            minWidth={0}
            mr={[2, 2, 3]}
            component={FormikRadioButton}
            useTimeout
            disabled={disableSiteContactOption}
          />
        </Flex>
      )}
      {showPropertyOwnerContactOption && (
        <Flex
          flexDirection="column"
          flexGrow={0.5}
          flexBasis={0}
          mr={[0, 0, 2]}
          mb={[2, 2, 0]}
        >
          <Field
            id={`${id}-property-owner-contact`}
            magnitude="small"
            label="Same as property owner"
            name={namePrefix}
            value="property-owner-contact"
            currentValue={currentValue}
            flexGrow={0.5}
            flexBasis={0}
            minWidth={0}
            mr={[2, 2, 3]}
            component={FormikRadioButton}
            useTimeout
            disabled={disablePropertyOwnerContactOption}
          />
        </Flex>
      )}
      <Flex flexDirection="column" flexGrow={0.5} flexBasis={0}>
        <Field
          id={`${id}-new-contact`}
          magnitude="small"
          label="New contact"
          name={namePrefix}
          value="new-contact"
          currentValue={currentValue}
          flexGrow={0.5}
          flexBasis={0}
          minWidth={0}
          component={FormikRadioButton}
          useTimeout
        />
      </Flex>
    </Flex>
  );
};
DisconnectionContactDetailsRoleRadio.defaultProps = {
  showSiteContactOption: true,
  showPropertyOwnerContactOption: true,
  disableSiteContactOption: false,
  disablePropertyOwnerContactOption: false,
};
